// extracted by mini-css-extract-plugin
module.exports = {"theIndustryAdvisors":"FRAME_theIndustryAdvisors__Gb_4x","fRAME":"FRAME_fRAME__wlvZ6","fRAME1":"FRAME_fRAME1__cqzJq"};